import '@banno/jha-wc/src/buttons/jha-button/jha-button';
import '@banno/jha-wc/src/icons/jha-icon-information';
import '@banno/jha-wc/src/icons/jha-icon-popout';
import '@banno/jha-wc/src/jha-tooltip/jha-tooltip.js';
import { TmBaseComponent } from '@treasury/presentation';
import { html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { CompanyUserChallengeDetailsViewModel } from '../../company-user-challenge-details.vm';
import './partials/symantec-credential-state.component';

@customElement('tm-bo-secure-token-details')
export class SecureTokenDetails extends TmBaseComponent {
    @property({ type: Object })
    public challengeDetails?: CompanyUserChallengeDetailsViewModel;

    public render() {
        return html`<div class="mb-5">
                <tm-bo-symantec-credential-state
                    .status=${this.challengeDetails?.tokenCredentialState}
                ></tm-bo-symantec-credential-state>
                ${this.challengeDetails?.symantecUserExists
                    ? html`<div class="mt-5">
                          <label>VIP User ID:</label>
                          <span class="font-bold">${this.challengeDetails?.secureTokenUserId}</span>
                      </div>`
                    : nothing}
            </div>
            <div class="mb-5">
                <label class="mr-3">
                    Manage Tokens<jha-tooltip
                        right
                        text="Access VIP Manager in order to reset or deactivate a token or to view audit reports."
                    >
                        <jha-icon-information class="cursor-pointer w-3 p-0"></jha-icon-information>
                    </jha-tooltip>
                </label>
            </div>
            <div class="mb-5">
                <div class="col-xs-12">
                    <jh-button
                        class="mr-4"
                        label="Access VIP Manager"
                        href="https://manager.vip.symantec.com/vipmgr/signin.v"
                        target="_blank"
                    >
                        <jha-icon-popout
                            class="fill-current"
                            slot="jh-button-icon"
                        ></jha-icon-popout>
                    </jh-button>
                </div>
            </div>`;
    }
}
